import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { ctaHandlers } from '../../../../utils/dashboard/stateSpecificUtils';

const ReusePriorApp = props => {

    const {
        modal:{
            modalData
        }
    } = props;

    const { goToSSAPStart } = ctaHandlers;

    return (
        <Fragment>
            <div className="gi-modal__body">
                <FormattedMessage id='modal.reuse_prior_app' tagName='p'/>
            </div>
            <div className="gi-modal__footer">
                <div className='controls'>
                    <div className='float-right'>
                        <button className="usa-button gi-button gi-button__primary"
                            onClick={() => goToSSAPStart(modalData)}>
                            <FormattedMessage id='further_action.cta.btn_start_new_application'/>
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ReusePriorApp;
